<template>
  <div class="listing-range">
    <div class="listing-range__values">
      <span>{{ lo }}{{ unit }}</span>
      <span>{{ hi }}{{ unit }}{{ hi >= max ? '+' : '' }}</span>
    </div>
    <div class="listing-range__track">
      <!-- The fill follows the thumb inset (10px radius) instead of a plain
           0-100% scale, otherwise it overshoots the thumb near the ends. -->
      <div
        class="listing-range__fill"
        :style="{
          left: `calc(10px + ${fraction(lo)} * (100% - 20px))`,
          width: `calc(${fraction(hi) - fraction(lo)} * (100% - 20px))`
        }"
      />
      <input
        type="range"
        :min="min"
        :max="max"
        :step="step"
        :value="lo"
        :aria-label="`${label} minimum`"
        @input="emit('update:modelValue', [Math.min(+$event.target.value, hi - step), hi])"
      />
      <input
        type="range"
        :min="min"
        :max="max"
        :step="step"
        :value="hi"
        :aria-label="`${label} maximum`"
        @input="emit('update:modelValue', [lo, Math.max(+$event.target.value, lo + step)])"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  min: { type: Number, required: true },
  max: { type: Number, required: true },
  step: { type: Number, default: 5 },
  modelValue: { type: Array, required: true },
  unit: { type: String, default: '' },
  label: { type: String, default: 'Bereik' }
});

const emit = defineEmits(['update:modelValue']);

// Held inside the slider's own scale: the value comes from the querystring or
// from localStorage, so it can predate a change of bounds (WHN-2148 lowered the
// living-area maximum). Unclamped, such a value put the fill past the end of
// the track and printed a number the slider cannot reach.
const clamp = (value) => Math.min(Math.max(value ?? props.min, props.min), props.max);

const lo = computed(() => clamp(props.modelValue[0]));
const hi = computed(() => clamp(props.modelValue[1]));
const fraction = (value) => (value - props.min) / (props.max - props.min);
</script>
